export default {
  selection: true,
  columns: [
    // 表格列的配置
    {
      label: "订单号",
      prop: "ord_no",
      type: "ordNo",
      fixed: true,
    },
    {
      label: "签约日期",
      prop: "create_time",
    },
    {
      label: "客户",
      prop: "cst_id_v",
      type: "companyName",
    },
    {
      label: "归属人",
      prop: "user_id_v",
    },
    {
      label: "订单金额",
      prop: "receivables",
    },
    {
      label: "收款状态",
      prop: "collection_status",
    },
    {
      label: "产品总数",
      prop: "pdt_sum",
    },
    {
      label: "出运状态",
      prop: "ship_status",
    },
    {
      label: "结算状态",
      prop: "ord_approval_id_v",
    },
    {
      label: "订单备注",
      prop: "ord_remark",
    },
    {
      label: "操作",
      type: "operate_btn",
      fixed: "right",
      width: "250px",
      prop: "",
    },
  ],
  forms: [
    {
      label: "是否收款:",
      prop: "is_create_col",
      type: "switch",
      span: 11,
      modelValue: "1",
      activeText: "是",
      inactiveText: "否",
      rule: [{ required: true }],
    },
    {
      label: "是否出运:",
      prop: "is_create_ship",
      type: "switch",
      span: 11,
      modelValue: "1",
      activeText: "是",
      inactiveText: "否",
      rule: [{ required: true }],
    },
    {
      label: "是否发票:",
      prop: "is_create_inv",
      type: "switch",
      span: 11,
      modelValue: "1",
      activeText: "是",
      inactiveText: "否",
      rule: [{ required: true }],
    },
    {
      label: "是否采购:",
      prop: "is_create_pur",
      type: "switch",
      span: 11,
      modelValue: "1",
      activeText: "是",
      inactiveText: "否",
      rule: [{ required: true }],
    },
  ],
};
